import { gql } from "@apollo/client";

const CheckoutCartFragment = gql`
  fragment CheckoutCartFragment on Order {
    _id
    orderNumber
    comment
    reference
    recipeConfiguration
    prescriber {
      contactNumber
      contactName
      contactEmail
      contactAddress
      contactPhone
    }
    clientId
    billingAddress {
      firstName
      lastName
      company
      addressLine
      addressLine2
      postalCode
      city
    }
    delivery {
      _id
      deliveryType
      deliveryDate
      wrapping
      deliveryOption
      deliveryAddressId
      ... on OrderDeliveryShipping {
        address {
          firstName
          lastName
          company
          addressLine
          addressLine2
          postalCode
          city
        }
      }
    }
    itemsTotal: total(category: ITEMS, useNetPrice: false) {
      amount
      currency
    }
    taxesTotal: total(category: TAXES) {
      amount
      currency
    }
    total(useNetPrice: false) {
      amount
      currency
    }
    items {
      _id
      configuration {
        key
        value
      }
      product {
        _id
        status
        media {
          _id
          file {
            _id
            small: url(version: "SMALL")
          }
          texts {
            _id
            title
          }
        }
        texts {
          _id
          title
          slug
        }
        ... on SimpleProduct {
          publicare {
            cutting
            migel
            isNotReturnable
            isOnlyForMedProfessionals
            clientMigelConformity
            institutionalMigelConformity
          }
          sku
          salesUnit
          publicareTranslatedSalesUnit
          salesQuantityPerUnit
          simulatedStocks {
            quantity
          }
        }
      }
      quantity
      total {
        amount
        currency
      }
      dispatches {
        shipping
        earliestDelivery
      }
    }
  }
`;

export default CheckoutCartFragment;
